module.exports = __webpack_public_path__ + "static/media/react1-archi.247b2165.png";